export { default } from './InterlibraryLoansStatusIcon';



// WEBPACK FOOTER //
// ./app/components/borrowing/interlibraryLoans/InterlibraryLoansStatusIcon/index.js